import React, {Component} from 'react';
import { Row, Col, FormControl } from 'react-bootstrap';
import { Checkbox, Radio } from 'react-icheck';
import PrintPreview from './PrintPreview';
import PdfStore from '../../stores/PdfStore';
import WorkdocStore from '../../stores/WorkdocStore';
import TextFieldModal from '../../component/element/TextFieldModal'

var NotificationSystem = require('react-notification-system');
const DEFAULT_PDF_CONFIG = {cash_title:'รถซ่อมเงินสด',cash_show_amount:true,show_fixing_day:false,show_ref_no:false,show_appointment_date:true,cash_payby_list:[]}
class PrintParkingCarDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {defaultTypePrint:'0',loading:false, data:{related_detail:{included_doc:this.getEmptyIncludeDoc()},pdf_config:DEFAULT_PDF_CONFIG}}

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){
    this._notificationSystem = this.refs.notificationSystem;
    this.loadParkingcarDoc()
  }

  loadParkingcarDoc() {
    let {workNo} = this.props
    let that = this
    this.setState({ loading: true })
    PdfStore.loadParkingcarDoc(workNo,function(result) {
      let data = result.data
      if(data.related_detail.included_doc!==undefined){
        data.related_detail['included_doc'] = data.related_detail.included_doc        
      }else{
        data.related_detail['included_doc'] = that.getEmptyIncludeDoc()        
      }
      
      data.pdf_config = Object.assign(DEFAULT_PDF_CONFIG,data.pdf_config)
      that.setState({data:data})
    })  
  }

  saveParkingcarDoc(data){
    let {workNo} = this.props
    let that =this

    WorkdocStore.saveWorkdocRelated(workNo,'parking_doc',data.related_detail,function(result){
      that._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'ทำการบันทึกรายละเอียดเอกสารประกอบเลขงานซ่อม ' + workNo + ' เรียบร้อย',
        level: 'info',
        position: 'tc',        
      });
    },function(){
      that._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'มีความผิดพลาดเกิดขึ้นในการบันทึกเอกสารประกอบเลขงานซ่อม ' + workNo + ' ',
        level: 'error',
        position: 'tc'
      });
    })
  }

  getEmptyIncludeDoc(){
    return {copy_car:false,copy_claim:false,copy_driver_licence:false,
      copy_id:false,copy_insurance:false,copy_other:false,copy_company_paper:false,other_text:''}
  }

  onRadioChange(key,value){
    
    let {data} = this.state
    let {included_doc} = data.related_detail
    
    included_doc[key] = !included_doc[key]
    let saving = true
    if(key==='copy_other'){
      if(included_doc[key]){
        
        let fieldInfo = {title:'ใส่ข้อมูลอื่นๆ',showClear:true,value:included_doc['other_text'] }
        this.refs.textFieldModal.loadInfo(fieldInfo)
        saving = false
      }else{
        included_doc['other_text'] = ''        
      }
    }
    data.related_detail.included_doc = included_doc
    this.setState({data:data})

    if(saving)
      this.saveParkingcarDoc(data)
  }

  onOtherSave(fieldInfo){
    let {data} = this.state
    let {included_doc} = data.related_detail
    included_doc['other_text'] = fieldInfo.value
    this.setState({data:data})

    this.saveParkingcarDoc(data)
  }

  renderLogoUrl(logoUrl,logo_width){
    let imgUrl = ''
    if (process.env.NODE_ENV == "development") {
      imgUrl = 'https://demo2.bigfix.co/korat/pdf/'+logoUrl
    }else{
      imgUrl = '../'+logoUrl
    }
    if(logoUrl!==undefined)
      return (<img src={imgUrl} style={{width:logo_width+'px'}}/>)
    else
      return  null
  }

  renderParkingStatus(receiving){
    let parkStatusTitle = 'รถจอด'
    if(receiving.park_status==='park'){
      parkStatusTitle = 'สถานะรถจอดซ่อม'
      return (<span>{parkStatusTitle}</span>)
    }else if(receiving.park_status==='no_park'){
      parkStatusTitle = 'สถานะรถไม่จอดซ่อม'

      if(receiving.order_part==='order')
        return <span>{parkStatusTitle} ...สั่งอะไหล่..</span>
      else if(receiving.order_part==='no_order')
        return <span>{parkStatusTitle} ...ไม่สั่งอะไหล่..</span>
      else if(receiving.order_part==='waiting')
        return <span>{parkStatusTitle} ...รอสั่งอะไหล่..</span>        
      else
        return ('')
    }

    
  }

  renderEntranceDate(receiving){
    if(receiving.park_status==='park'){
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth()+1; //January is 0!
      var yyyy = today.getFullYear()+543;
      let h = today.getHours(); // => 9
      let m = today.getMinutes(); // =>  30
      let entrance_date = dd+'/'+mm+'/'+yyyy
      let entrance_time = h+':'+m
      return (<span>วันที่รับรถเข้าซ่อม ...{entrance_date}... เวลา ...{entrance_time}...</span>)
    }else{
      return (<span>วันที่รับรถเข้าซ่อม ...{receiving.entrance_date}... เวลา ...{receiving.entrance_time}...</span>)
    }
  }

  renderFixingDay(receiving){
    if(receiving.fixing_day>0)
      return (<span>ระยะเวลาซ่อมจำนวน {receiving.fixing_day} วัน</span>)
    else
      return (<span></span>)
  }

  renderTel(receiving){
    if(receiving.other_tel){
      return (<div><h1>โทร ...{receiving.tel}... </h1><p/><h1>เบอร์อื่น...{receiving.other_tel}...</h1></div>)  
    }
    return (<h1>โทร ...{receiving.tel}...</h1>)
  }

  renderOtherText(otherText){
    if(otherText!==''){
      return (<span> อื่นๆ....{otherText}....</span>)
    }else{
      return (<span> อื่นๆ.................................................</span>)
    }
  }

  renderRemark(remark){
    if(remark!==''&&remark!=='checked'&&remark!==undefined){
      return (<div>หมายเหตุ....{remark}....</div>)
    }else{
      return (<div>หมายเหตุ.................................................</div>)
    }
  }

  renderExcess(car){
    let {data} = this.state
    let insurer = data.insurer

    if (insurer!==undefined && insurer.insurer_id*1!==0) {
      if(car.excess!==undefined && car.excess>0){
        return (<span>ค่าเสียหายส่วนแรก(Excess) ...{car.excess}...บาท</span>)
      }else if(car.diff_payment!==undefined && car.diff_payment>0){
        return (<span>มีค่าส่วนต่างจ่ายเพิ่ม ...{car.diff_payment}...บาท</span>)
      }else if(car['50discount']!==undefined && car['50discount']>0){
        return (<span>มีค่าส่วนต่างจ่ายเพิ่ม ...{car['50discount']}...บาท</span>)   
      }else{
        return (<span></span>)
      }
    }else{
      return (<span></span>)
    }
  }

  getNumberFormat(val) {
    if (val!==''&&val!==undefined&&val!==null&&!isNaN(val)) {
      return parseFloat(val).toLocaleString(undefined, {maximumFractionDigits: 2})
    }
    return val
  }

  renderPayByCash(){
    let {data} = this.state
    let {amount,pdf_config} = data
    let text = ''
    if (data.insurer!=undefined) {
      let insurer = data.insurer

      if (insurer.insurer_id*1===0) {
        text = 'จำนวน ...'+this.getNumberFormat(amount)+'... '
        if(insurer.init_quote_price!==undefined && insurer.init_quote_price>0) {
          text = 'เสนอราคาเบื้องต้น ...'+this.getNumberFormat(insurer.init_quote_price)+'... '
        }
      }
    }

    if(pdf_config.cash_show_amount){
      return (
        <span>{pdf_config.cash_title} {text} บาท</span>
      ) 
    }else{
      return (
        <span>{pdf_config.cash_title}</span>
      )       
    }
  }

  renderPayByCashRow(insurer_check,insurer_check_print){
    let {data} = this.state
    let {amount,pdf_config,insurer} = data
    
    if(pdf_config.cash_payby_list!==undefined && pdf_config.cash_payby_list.length>0){
      return pdf_config.cash_payby_list.map((item,index)=>{        
        let cbTitle = '',checked=false
        if(insurer!==undefined && item.name===insurer.insurer_name){
          cbTitle = 'checkbox-check'
          checked = true
        }
        return (<tr>
          <td className="text-right">
            <Checkbox
              onChange=""
              checked={checked}
              checkboxClass={'icheckbox_square-blue '+cbTitle}
              increaseArea="20%"
              label=""
            >
            </Checkbox>
          </td>
          <td>
            <span>{item.name}</span>                   
          </td>
        </tr> )
      })
    }else{
      return (
        <tr>
          <td className="text-right">
            <Checkbox
              onChange=""
              checked={insurer_check[0]}
              checkboxClass={'icheckbox_square-blue '+insurer_check_print[0]}
              increaseArea="20%"
              label=""
            >
            </Checkbox>
          </td>
          <td>
            {this.renderPayByCash()}                      
          </td>
        </tr>      
      )
    }
  }

  renderComponentPage(item,index){
    const {mode} = this.props
    let title = 'ใบรับรถเข้าจอดซ่อม'
    if(mode==='1'){
      title = 'ใบรับรถเข้าจอดซ่อม'
    }else if(mode==='2'){
      title = 'ใบรับรถไม่จอดซ่อม'
    }
    let {data,defaultTypePrint} = this.state
    let {pdf_config}  = data
    let {copy_company_paper,copy_car,copy_claim,copy_driver_licence,copy_id,copy_insurance,copy_other,other_text} = data.related_detail.included_doc

    let car = []
    let driver = []
    let insurer = []
    let insurer_check = [false,false]
    let insurer_check_print = ['','']
    let insurer_radio = [false,false]
    let insurer_radio_print = ['','']
    let disabled = false
    let receiving = []
    let owner = []
    let amount = ''
    let insurer_name = '...........................'
    let remark_check = false
    let remark_check_print = ''
    
    if (data.car!=undefined) {
      car = data.car
    }
    if (data.driver!=undefined) {
      driver = data.driver
    }
    if (data.insurer!=undefined ) {
      insurer = data.insurer
      if(insurer.insurer_id!==undefined){
        if (insurer.insurer_id==0) {
          insurer_check[0] = true
          insurer_check[1] = false
          insurer_check_print[0] = 'checkbox-check'
          insurer_check_print[1] = ''
          amount = data.amount
        } else {
          insurer_name = insurer.insurer_name
          insurer_check[0] = false
          insurer_check[1] = true
          insurer_check_print[0] = ''
          insurer_check_print[1] = 'checkbox-check'
          disabled = true
          if (car.accident_type=='รถประกัน') {
            insurer_radio_print[0] = 'radio-check'
            insurer_radio_print[1] = ''
            insurer_radio[0] = true
            insurer_radio[1] = false
          } else {
            insurer_radio_print[0] = ''
            insurer_radio_print[1] = 'radio-check'
            insurer_radio[0] = false
            insurer_radio[1] = true
          }
        }
      }
    }
    if (data.receiving!==undefined) {
      receiving = data.receiving
      if (receiving.remark!='') {
        remark_check = true
        remark_check_print = 'checkbox-check'
      } else {
        remark_check = false
        remark_check_print = ''
      }
    }
    if (data.owner!==undefined) {
      owner = data.owner
    }

    return(
      <div className='font-print' key={index}>
        <header>
          <h2 className="text-right">{title}</h2>
        </header>  
        <article className={"article-company "+data.logo_class}>
          <div style={{width:data.logo_width+'px',textAlign:'center',lineHeight:'70px'}}>
            {this.renderLogoUrl(data.logo_url,data.logo_width)}
          </div>
          <section className="font-20" style={{width:'85%',marginLeft:'10px',paddingTop:(data.logo_class=='bg-logo-absolute'?'50px':'0')}}>
            <strong>
              <p style={{lineHeight:'0.7'}}>{data.company_name} (สำนักงานใหญ่)</p>
              <p style={{lineHeight:'0.7'}}>{data.company_addr} </p>
              <p style={{lineHeight:'0.7'}}>โทร {data.company_tel} โทรสาร {data.company_fax}</p>
            </strong>
          </section>
          <section className='text-center sec-copy-doc'>
            <span style={{display:defaultTypePrint=='0'?'none':''}}>{item.type=='ori'?'ต้นฉบับ':item.type=='copy'?'สำเนา':''}</span>
          </section>
        </article>
        <div className="box-parking-car-doc">
          <div style={{display:'flex'}}>
            <div >
              <table className="table table-parking-car-doc" style={{width:'320px'}}>
                <tbody>
                  <tr>
                    <td></td>
                    <td>
                      {this.renderEntranceDate(receiving)}                      
                    </td>
                  </tr>
                  <tr style={{display:pdf_config.show_fixing_day?'':'none'}}>
                    <td></td>
                    <td>
                      {this.renderFixingDay(receiving)}                      
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      ชื่อลูกค้า ...{receiving.entrance_name}...
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      ยี่ห้อรถ ...{car.brand}... ทะเบียน ...{car.car_registration_no}..{car.province}.
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      รุ่นรถ ...{car.model}... สีรถ ...{car.car_color}...
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      เลขกิโลเมตร ...{car.mileage}...
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      {this.renderParkingStatus(receiving)}                      
                    </td>
                  </tr>
                  <tr>
                    <td className="text-right">
                      <Checkbox
                        onChange=""
                        checked={insurer_check[1]}
                        checkboxClass={'icheckbox_square-blue '+insurer_check_print[1]}
                        increaseArea="20%"
                        label=""
                      >
                      </Checkbox>
                    </td>
                    <td>
                      รถซ่อมประกันภัย ...{insurer_name}...
                    </td>
                  </tr>
                  <tr>
                    <td>
                      
                    </td>
                    <td>
                      <Radio
                        onChange=""
                        checked={insurer_radio[0]}
                        radioClass={'iradio_square-blue '+insurer_radio_print[0]}
                        increaseArea="20%"
                        label=" ประกัน"
                      >
                      </Radio>
                      &nbsp;
                      <Radio
                        onChange=""
                        checked={insurer_radio[1]}
                        radioClass={'iradio_square-blue '+insurer_radio_print[1]}
                        increaseArea="20%"
                        label=" คู่กรณี"
                      >
                      </Radio>
                    </td>
                  </tr>                                    
                  {
                    this.renderPayByCashRow(insurer_check,insurer_check_print)
                  }
                  <tr>
                    <td></td>
                    <td>
                      {this.renderExcess(car)}                      
                    </td>
                  </tr>  
                  <tr>
                    <td></td>
                    <td>
                      {this.renderTel(receiving)}
                    </td>
                  </tr>     
                  <tr style={{display:pdf_config.show_ref_no?'':'none'}}>
                    <td></td>
                    <td>
                      ลำดับเรื่อง ...{(receiving.ref_no!==undefined)?receiving.ref_no:''}...
                    </td>
                  </tr>                 
                  <tr>
                    <td></td>
                    <td>
                      ผู้รับผิดชอบงาน ...{receiving.checking_by}...
                    </td>
                  </tr>              
                </tbody>  
              </table>
            </div>
            <div  style={{float:'right'}}>
              <table className="table table-parking-car-doc">
                <tbody>
                  <tr>
                    <td colSpan={2} className="text-center">
                      เอกสารที่ต้องนำมาประกอบ
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Checkbox                                                
                        checked={copy_claim}
                        checkboxClass={'icheckbox_square-blue '+(copy_claim?'checkbox-check':'')}
                        increaseArea="20%"
                        label=" สำเนาตารางกรมธรรม์"
                        onChange={this.onRadioChange.bind(this,'copy_claim')}
                      />
                      
                    </td>
                    <td>
                      <Checkbox                        
                        checked={copy_id}
                        checkboxClass={'icheckbox_square-blue '+(copy_id?'checkbox-check':'')}
                        increaseArea="20%"
                        label=" สำเนาบัตรประชาชน"
                        onChange={this.onRadioChange.bind(this,'copy_id')}
                      />
                      
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Checkbox                        
                        checked={copy_car}
                        checkboxClass={'icheckbox_square-blue '+(copy_car?'checkbox-check':'')}
                        increaseArea="20%"
                        label=" สำเนาทะเบียนรถ"
                        onChange={this.onRadioChange.bind(this,'copy_car')}
                      />
                      
                    </td>
                    <td>
                      <Checkbox                        
                        checked={copy_insurance}
                        checkboxClass={'icheckbox_square-blue '+(copy_insurance?'checkbox-check':'')}
                        increaseArea="20%"
                        label=" สำเนา พ.ร.บ. (เฉพาะคู่กรณี)"
                        onChange={this.onRadioChange.bind(this,'copy_insurance')}
                      />
                      
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Checkbox                        
                        checked={copy_driver_licence}
                        checkboxClass={'icheckbox_square-blue '+(copy_driver_licence?'checkbox-check':'')}
                        increaseArea="20%"
                        label=" สำเนาใบอนุญาตขับขี่"
                        onChange={this.onRadioChange.bind(this,'copy_driver_licence')}
                      />
                      
                    </td>
                    <td>
                      <Checkbox                        
                        checked={copy_company_paper}
                        checkboxClass={'icheckbox_square-blue '+(copy_company_paper?'checkbox-check':'')}
                        increaseArea="20%"
                        label=" เอกสารใบออนไลน์ บ.ต่างๆ"
                        onChange={this.onRadioChange.bind(this,'copy_company_paper')}
                     />
                      
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2} >
                      <Checkbox                        
                        checked={copy_other}
                        checkboxClass={'icheckbox_square-blue '+(copy_other?'checkbox-check':'')}
                        increaseArea="20%"
                        label={this.renderOtherText(other_text)}
                        onChange={this.onRadioChange.bind(this,'copy_other')}                        
                      />
                      
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2}>
                      <br/>
                    </td>
                  </tr>  
                  <tr>
                    <td colSpan={2}>
                      ลงชื่อ............................................เจ้าของรถ / ผู้นำรถเข้าซ่อม
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2}>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(.........{receiving.entrance_name}..........)
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2}>
                      ลงชื่อ..........................................เจ้าของอู่ / พนักงานรับรถ
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2}>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(.........{receiving.receiving_by}.........)
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2}>
                      <br/>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2}>
                      {this.renderRemark(receiving.remark)}
                    </td>
                  </tr>
                  <tr style={{display:(pdf_config.show_appointment_date && pdf_config.show_appointment_date===true?'':'none')}}>
                    <td colSpan={2}>
                      วันที่นัดรับรถ .........{receiving.appointment_date}......เวลา.....{receiving.appointment_time}...
                    </td>
                  </tr>
                </tbody>  
              </table>
            </div>
          </div>   
          <Row>
            <Col md={12}>
            *หมายเหตุ เอกสารฉบับนี้ เป็นการนัดหมาย  เบื้องต้น  ชั่วคราว เท่านั้น
            </Col>
          </Row> 
          <Row>
            <Col md={12} className='text-red'>
            *หมายเหตุ กรุณาตรวจสอบและนำทรัพย์สินของท่านออกจากรถ ก่อนนำรถเข้าจอดซ่อม หากเกิดความเสียหายหรือสูญหาย ทาง {data.company_name} จะไม่รับผิดชอบทุกกรณี
            </Col>
          </Row> 
        </div>   
        <TextFieldModal ref='textFieldModal'
        confirmTitle='บันทึก'
        onConfirm={this.onOtherSave.bind(this)}
        />
        <NotificationSystem ref="notificationSystem" />
      </div>
    )
  }

  onTypePrintChange(e) {
    this.setState({defaultTypePrint:e})
  }

  render(){
    let {loading,defaultTypePrint} = this.state
    let pages = [{page:1,type:'ori'}]
    if (defaultTypePrint=='3')
      pages = [{page:1,type:'ori'},{page:2,type:'copy'}]
    else if (defaultTypePrint=='2')
      pages = [{page:1,type:'copy'}]

    let title = '';
    if(this.props.workNo!==undefined){
      title = 'งานเลขที่'+this.props.workNo
    }
    return (
      <PrintPreview 
        loading={loading} 
        leftBarTitle={'ใบรับรถเข้าจอดซ่อม '+title}
        onTypePrintChange={this.onTypePrintChange.bind(this)}
        defaultTypePrint={this.state.defaultTypePrint}
        showPageNumber={false}
      >
        {
          pages.map((item,index) => {
            return(
              this.renderComponentPage(item,index)
            )
          })
        }     
      </PrintPreview>
    )
  }
}


PrintParkingCarDoc.defaultProps = {
  title: 'ใบรับรถเข้าจอดซ่อม',  
  mode : '1'
}
export default PrintParkingCarDoc;





// WEBPACK FOOTER //
// ./src/view/print/PrintParkingCarDoc.js